import { defaultLocale } from '@/i18n';
import { getSlugFromCountry } from './country-slugs';
import { getSlugFromPage } from './page-slugs';

/**
 * Get the localized path for a given route
 * For default locale (en), returns path without prefix
 * For other locales, returns path with locale prefix
 */
export function getLocalizedPath(path: string, locale: string): string {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Handle root path
  if (!cleanPath || cleanPath === '') {
    return locale === defaultLocale ? '/' : `/${locale}`;
  }
  
  // For default locale, return path without prefix
  if (locale === defaultLocale) {
    return `/${cleanPath}`;
  }
  
  // For other locales, add locale prefix
  return `/${locale}/${cleanPath}`;
}

/**
 * Get the localized home path
 */
export function getLocalizedHome(locale: string): string {
  return locale === defaultLocale ? '/' : `/${locale}`;
}

/**
 * Get the localized country page path
 * Uses translated slugs for each locale
 */
export function getLocalizedCountryPath(country: string, locale: string): string {
  const slug = getSlugFromCountry(country, locale);
  if (!slug) {
    // Fallback to default if slug not found
    return getLocalizedPath(country, locale);
  }
  return getLocalizedPath(slug, locale);
}

/**
 * Get the localized page path (for legal, privacy-policy, refund-policy)
 * Uses translated slugs for each locale
 */
export function getLocalizedPagePath(page: string, locale: string): string {
  const slug = getSlugFromPage(page, locale);
  if (!slug) {
    // Fallback to default if slug not found
    return getLocalizedPath(page, locale);
  }
  return getLocalizedPath(slug, locale);
}

